import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, Progress } from '@mantine/core';
export const MRT_ProgressBar = ({ isTopToolbar, table, }) => {
    const { options: { mantineProgressProps }, getState, } = table;
    const { isSaving, showProgressBars } = getState();
    const linearProgressProps = mantineProgressProps instanceof Function
        ? mantineProgressProps({ isTopToolbar, table })
        : mantineProgressProps;
    return (_jsx(Collapse, { in: isSaving || showProgressBars, sx: {
            bottom: isTopToolbar ? 0 : undefined,
            position: 'absolute',
            top: !isTopToolbar ? 0 : undefined,
            width: '100%',
        }, children: _jsx(Progress, Object.assign({ animate: true, "aria-busy": "true", "aria-label": "Loading", radius: 0, value: 100 }, linearProgressProps)) }));
};
//# sourceMappingURL=MRT_ProgressBar.js.map